import { http } from 'vue'

export default {
  // load user from the API server by e-mail
  loadUserToEmployeeRegistration (context, params = {}) {
    return http.post('dashboard/check_user', params.data)
  },
  // load employees from the API server
  loadEmployees (context, params = {}) {
    return http.get('employees?company_id=' + params.companyId)
  },
  // create employees at the API server
  postEmployee (context, params = {}) {
    return http.post('employees', params.data)
  },
  // edit employees at the API server
  putEmployee (context, params = {}) {
    return http.put('employees/' + params.id, params.data)
  },
  // delete employees at the API server
  deleteEmployee (context, params = {}) {
    return http.delete('employees/' + params.id + '?company_id=' + params.companyId)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/employees/actions.js